import React, { ChangeEvent, useEffect } from 'react';
import { FaqProps } from '../index';
import { Form } from '../../../../components';
import {
  InstructionWrapper,
  TextField,
  ToggleSwitch
} from '../../../../components/fields';
import Heading from '../../../../_global/components/heading/Heading';
import './_styles.scss';
import { publish, useStateReducer } from '../../../../hooks';
import { StateTopicEnum } from '../../../../enums';
import { validateObject } from '../../../../utilities';
import { Regexes } from '../../../../definitions';

export default function CreateItem({
  data: { order, question, answer, is_active }
}: FaqProps) {
  const [state, setState] = useStateReducer({
    order: 0,
    question: '',
    answer: '',
    is_active: false
  });

  const [displayName, setDisplayName] = React.useState(
    `${question ?? ''} }
      }
`.trim()
  );

  const errors = validateObject(
    {
      order: {
        regex: Regexes.positiveInt,
        message: 'Faq order number must be a valid number.'
      },
      question: {
        regex: Regexes.anyContentRegex,
        message: 'Question is required.'
      },
      answer: {
        regex: Regexes.anyContentRegex,
        message: 'Answer is required.'
      }
    },
    state
  );

  const isValid = () => {
    if (errors['order']) return false;
    if (errors['question']) return false;
    if (errors['answer']) return false;
    return true;
  };

  React.useEffect(() => {
    setDisplayName(`${state.question ?? '-'}`);
    publish(StateTopicEnum.IsValid, isValid());
    publish(StateTopicEnum.EditItem, state);
    // eslint-disable-next-line
  }, [state.order, state.question, state.answer, state.is_active]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string
  ) => {
    let value: string | boolean = event.currentTarget.value;
    // @ts-ignore
    if (event.target.type === 'checkbox') value = event.target.checked;
    setState({ [key]: value });
  };

  return (
    <div id='faq-create-item'>
      <Heading name={displayName} />
      <Form title='Faq Details'>
        <InstructionWrapper
          text='Enter Faq order (Sequence number) here.'
          error={errors['order']}
          row
        >
          <TextField
            label='Order'
            value={state.order != 0 ? state.order : ''}
            onChange={(event) => handleChange(event, 'order')}
            error={!!errors['order']}
          />
          <ToggleSwitch
            label='Is active'
            className={'display-block'}
            value={state.is_active}
            onChange={(event) => handleChange(event, 'is_active')}
          />
        </InstructionWrapper>

        <InstructionWrapper
          text='Enter Faq here.'
          error={errors['question']}
          row
        >
          <TextField
            label='Question'
            multiline={true}
            value={state.question}
            onChange={(event) => handleChange(event, 'question')}
            error={!!errors['question']}
          />
        </InstructionWrapper>

        <InstructionWrapper
          text='Enter Faq answer here.'
          error={errors['answer']}
          row
        >
          <TextField
            label='Answer'
            multiline={true}
            value={state.answer}
            onChange={(event) => handleChange(event, 'answer')}
            error={!!errors['answer']}
          />
        </InstructionWrapper>
      </Form>
    </div>
  );
}
